<template>
    <a-select :value="messagestypecode" placeholder="输入业务类型名称"  style="width: 150px"
         :filter-option="true" :not-found-content="null" 
        @change="handleChange">
        <a-select-option v-for="d in messagetypeList" :key="d.messagestypecode">
            {{ d.messagestypename }}
        </a-select-option>
    </a-select>

</template>
<script>
export default {
    data() {
        return {
            messagetypeList: [],
            messagestypecode: '',
        }
    },

    props: {
        channelcode: String,
        defaultmessagetypecode:String,
        showAll:Boolean
    },

    methods: {

        handleChange(value) {

            this.messagestypecode = value
            let targetData = this.messagetypeList.filter((item) => {
                return item.messagestypecode == value
            });
            if (targetData.length > 0) {
                this.$emit('onmessagestypecodeChange', targetData[0]);
            }
            else{
                this.message.error('未查到当前渠道下对应的业务分类：' + this.messagestypecode)
                this.messagestypecode = ''
            }
        },
        doSearch() {
            let that = this;
            let c_params = {
                urlparams: false,
                channelcode: this.channelcode,
            }

            that.$store.dispatch({
                type: "mcmsmanager/queryListByChannelCode",
                params: c_params,
                showMsg: false
            }).then((res) => {
                if (res.data.success == 1) {
                    that.messagetypeList = [];
                    if(that.showAll){
                        that.messagetypeList.push({
                            messagestypecode:'',
                            messagestypename:'全部'
                        });
                    }
                    let result = res.data.data;
                    if (!result) {
                        that.message.error("未查询到渠道");
                        return;
                    }
                    that.messagetypeList =  that.messagetypeList.concat(result) 
                    let query = that.$route.query;
                    if(that.defaultmessagetypecode){
                        that.messagestypecode = that.defaultmessagetypecode
                        that.handleChange(that.messagestypecode)
                    }
                    else if(query.messagestypecode){
                        that.messagestypecode = query.messagestypecode
                        that.handleChange(that.messagestypecode)
                    }
                    else if(query.messagestypename){
                        let tempResult = that.messagetypeList.filter((item) => {
                            return item.messagestypename == query.messagestypename
                        });
                        if(tempResult.length > 0){
                            that.messagestypecode = tempResult[0].messagestypecode;
                            that.handleChange(that.messagestypecode)
                        }
                    }
                    else if(that.messagetypeList.length > 0){
                        that.messagestypecode = that.messagetypeList[0].messagestypecode
                        that.handleChange(that.messagestypecode)
                    }
                    else{
                        that.messagetypeList = [];
                        that.messagestypecode = ''
                        that.message.error("当前渠道没有可用业务类型！！")
                    }
                    
                }
            }).catch((e) => {
                console.log(e)
            });
        },

    },
    mounted() {},
    watch: {
        'channelcode'(newVal) {
            if (newVal) {
                this.doSearch();
            }
        }
    },
};
</script>

<style scoped>

</style>